import { PillMarquee, type ContentType } from './pill-marquee';

// Cancer specific data and component
// TODO: drive from backend/Sanity
const defaultCancerTypes = [
  'Pancreatic cancer',
  'Head and neck cancer',
  'Lymphoma',
  'Prostate cancer',
  'Bladder cancer',
  'Liver cancer',
  'Lung cancer',
  'Colon cancer',
  'Thyroid cancer',
  'Uterine cancer',
  'Multiple myeloma',
  'Brain cancer',
  'Melanoma',
  'Testicular cancer',
  'Cervical cancer',
  'Leukemia',
  'Kidney cancer',
  'Stomach cancer',
  'Breast cancer',
  'Esophageal cancer',
  'Ovarian cancer',
];

// Cancer-specific component using the generic PillMarquee
interface CancerMarqueeProps {
  cancerTypes?: string[];
  className?: string;
  'data-content-type'?: ContentType;
}

export const CancerMarquee = ({ className = '', ...props }: CancerMarqueeProps) => {
  const pillItems = defaultCancerTypes.map((cancer) => ({
    text: cancer,
  }));

  return (
    <PillMarquee
      items={pillItems}
      pillStyles={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', color: 'white', border: '1px solid white' }}
      className={className}
      {...props}
    />
  );
};
